import { CompareEnergyConsumptionResponse } from "../pages/customer/energy-management/models/compare-energy-consumption-response";
import { apiSlice } from "../stores/base/api-slice";

const consumptionEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		compareMeterConsumptionEnergyUsage: builder.query<CompareEnergyConsumptionResponse, number>({
			query: comparationType => ({
				url: `/vending/meter-consumption/compare-energy-usage?ComparationType=${comparationType}`,
				method: "GET",
			}),
		}),

	}),
});

export const { useCompareMeterConsumptionEnergyUsageQuery } = consumptionEndpoints;
